<template>
  <WorldMap></WorldMap>
  <div class="header drop-shadow">
    <VOCLogo></VOCLogo>
    <TradingGoods></TradingGoods>
  </div>
  <TimelineBar></TimelineBar>
</template>

<script>
import VOCLogo from "@/components/VOCLogo.vue";
import TradingGoods from "@/components/TradingGoods.vue";
import TimelineBar from "@/components/TimelineBar.vue";
import WorldMap from "@/components/WorldMap.vue";
export default {
  name: "InteractiveMapView",
  components: {
    VOCLogo,
    TradingGoods,
    TimelineBar,
    WorldMap,
  },
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {}
};
</script>

<style scoped>
.header {
  display: flex;
  pointer-events:none;
  justify-content: space-between;
  margin: 2em;
}
</style>